

















































































































import { errorNotification } from '@/includes/services/NotificationService'
import { InputSetups } from '@/mixins/input-setups'
import { Slot } from '@/includes/types/Slots.types';

import EmptyData from 'piramis-base-components/src/components/EmptyData/EmptyData.vue'
import { tooltipTrigger } from "piramis-base-components/src/shared/utils/tooltipTrigger";
import { IterableItemFactory, IterableListItem } from "piramis-base-components/src/shared/utils/IterableItemFactory";
import TimePickerInput from 'piramis-base-components/src/components/Pi/fields/TimePickerInput/TimePickerInput.vue';
import SwitchInput from 'piramis-base-components/src/components/Pi/fields/SwitchInput/SwitchInput.vue';

import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { cloneDeep } from "lodash";

type LocalSlots = Array<IterableListItem<Slot>>

@Component({
  components: {
    EmptyData,
    TimePickerInput,
    SwitchInput
  },
  methods: {
    tooltipTrigger,
  }
})
export default class SlotsList extends Mixins<InputSetups>(InputSetups) {
  @Prop() slots!: Array<Slot>

  @Prop({ type: Boolean, default: false }) adsOnly!: boolean

  @Emit()
  updateSlots(slots: LocalSlots) {
    return this.getRawSlots(slots)
  }

  @Watch('slots', { immediate: true })
  onSlotsChange(slots: Array<Slot>) {
    this.localSlots = slots.map(this.iterableItemFactory.create)
  }

  iterableItemFactory = new IterableItemFactory()

  localSlots: LocalSlots | null = null

  isSlotModalOpen = false

  slotModel: IterableListItem<Slot> | null = null

  slotModalType: 'new' | 'edit' = 'new'

  weekDayTitles = {
    1: this.$t('pi_base_weekday_monday_key').toString(),
    2: this.$t('pi_base_weekday_tuesday_key').toString(),
    3: this.$t('pi_base_weekday_wednesday_key').toString(),
    4: this.$t('pi_base_weekday_thursday_key').toString(),
    5: this.$t('pi_base_weekday_friday_key').toString(),
    6: this.$t('pi_base_weekday_saturday_key').toString(),
    7: this.$t('pi_base_weekday_sunday_key').toString(),
  }

  get weekDaysFrontend() {
    return (this.localSlots ?? []).reduce<Record<number, { slots: LocalSlots }>>((weekdaySlots, data) => {
      weekdaySlots[data.value.active_day_of_week].slots.push(data)

      weekdaySlots[data.value.active_day_of_week].slots.sort((a, b) => this.getMomentTime(a.value.time).valueOf() - this.getMomentTime(b.value.time).valueOf())

      return weekdaySlots
    }, {
      1: { slots: [] },
      2: { slots: [] },
      3: { slots: [] },
      4: { slots: [] },
      5: { slots: [] },
      6: { slots: [] },
      7: { slots: [] },
    })
  }

  createNewSlot() {
    return this.iterableItemFactory.create<Slot>({
      time: '',
      ads_only: this.adsOnly,
      allow_styles: [],
      active_day_of_week: 1
    })
  }

  removeSlot(guid: string) {
    if (this.localSlots) {
      this.localSlots = this.localSlots.filter(s => s.guid !== guid)

      this.updateSlots(this.localSlots)
    }
  }

  getRawSlots(slots: LocalSlots) {
    return slots.map(s => s.value)
  }

  get modalTitle(): string {
    if (this.slotModalType === 'new') return this.$t('slot_modal_create').toString()
    if (this.slotModalType === 'edit') return this.$t('slot_modal_edit').toString()

    return ''
  }

  getMomentTime(time: string) {
    return moment(time, 'HH:mm')
  }

  formatSlotTime(time: string): string {
    return this.getMomentTime(time).format('HH:mm')
  }

  editSlot(slot: LocalSlots[0]): void {
    this.slotModalType = 'edit'
    this.slotModel = cloneDeep(slot)

    this.isSlotModalOpen = true
  }

  slotTimeExists(slot: Slot): boolean {
    return (this.localSlots ?? []).some(s => s.value.time === slot.time && s.value.active_day_of_week === slot.active_day_of_week)
  }

  getSlotIfExists(guid: string) {
    return (this.localSlots ?? []).find(s => s.guid === guid)
  }

  handleOkButtonClick(): void {
    if (this.slotModel && this.localSlots) {
      if (this.slotModalType === 'new') {
        this.handleAddSlotButton()
      } else {
        const slot = this.getSlotIfExists(this.slotModel.guid)

        if (slot) {
          slot.value = { ...this.slotModel.value }

          this.updateSlots(this.localSlots)

          this.isSlotModalOpen = false
        }
      }
    }
  }

  openAddSlotModal(dayIndex: string): void {
    this.slotModalType = 'new'

    this.slotModel = this.createNewSlot()
    this.slotModel.value.active_day_of_week = Number.parseInt(dayIndex)

    this.isSlotModalOpen = true
  }

  handleModalCancel(): void {
    this.slotModel = null
  }

  handleAddSlotButton(): void {
    if (this.slotModel && this.localSlots) {
      if (this.slotTimeExists(this.slotModel.value)) {
        errorNotification(this.$t('slot_exists_error').toString())
      } else {
        this.localSlots.push(this.slotModel)

        this.isSlotModalOpen = false

        this.updateSlots(this.localSlots)
      }
    }
  }
}
